import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { observer } from 'mobx-react';

import routes from 'core/routes';
import { useStore } from 'utils/hooks/store';
import { canAccessRisksProduct } from 'utils/roles/permissions';

const ActionsAllRedirect = observer((): React.ReactElement => {
  const { session } = useStore();
  const { search } = useLocation();
  const tab = new URLSearchParams(search).get('tab');

  const hasAuditsLicense = (session.user?.licenses?.workflows && session.user?.scheduleEnabled) ?? false;
  const hasAcknowledgements =
    (session.user?.documentAcknowledgementsEnabled && session.user?.licenses?.documents) ?? false;

  // A stale link to a surface the user can't see degrades to Tasks rather than an empty/blocked page.
  let to = routes.dashboard.tasks.list.toString();
  if (tab === 'audits' && hasAuditsLicense) {
    to = routes.dashboard.tasks.audits.toString();
  } else if (tab === 'acknowledgements' && hasAcknowledgements) {
    to = routes.dashboard.tasks.acknowledgements.toString();
  } else if (tab === 'risks' && canAccessRisksProduct(session.user)) {
    to = routes.dashboard.tasks.risks.toString();
  }

  return <Navigate replace to={to} />;
});

export default ActionsAllRedirect;
